
export enum QuoteChangeDirection {
    NO_CHANGE, UP, DOWN
}
